__webpack_require__.p = "/assets/turbo/ba97a98e/universalat/_next/";